// Sistema de perfis de cor (Build 5, "Opções de visualização"). Substitui o
// sistema antigo de 4 tokens soltos por 8 perfis completos (4 Dark + 4
// Claro), cada um cobrindo as areas pedidas: dashboard geral, sidebar de
// navegacao, painel de acoes da conversa, e ReplyBox nos 3 modos (Mensagem,
// Mensagem privada, IAra), mais a cor de marca, o botao Assistente IAra
// On/Off e a cor da barra do navegador (quando instalado como app).
//
// Aplicado via <style id="odtravel-runtime-theme"> injetado no <head>, sem
// rebuild: salva em Account.settings.odtravel_color_profiles (overrides por
// token, por perfil) + odtravel_active_color_profile ({ dark, light }).
//
// Duas areas (sidebar de navegacao e painel de acoes da conversa) usam
// variaveis CSS dedicadas (--sidebar-nav-*, --conv-action-text,
// --reply-msg-*, --reply-private-text, ver _next-colors.scss) em vez de
// reaproveitar as escalas nativas (--slate-*, --amber-*), porque o pedido
// era controle INDEPENDENTE: mudar o texto da sidebar nao pode mudar
// nenhuma outra parte do produto que compartilhe a mesma escala. O escopo
// e feito por classe (.odtravel-sidebar-nav, .odtravel-conv-action, e as
// classes .reply-box / .is-private / .is-iara-consult que ja existiam),
// aliasando --slate-11/--slate-12 localmente pra dentro de cada bloco -
// assim nenhum componente filho precisa ser editado individualmente.
export const COLOR_TOKENS = [
  {
    key: 'dashboard-bg',
    label: 'Fundo geral (dashboard, lista de conversas, area de mensagens)',
    group: 'Geral',
  },
  { key: 'brand', label: 'Cor de destaque (marca)', group: 'Geral' },
  {
    key: 'browser-titlebar',
    label: 'Barra do navegador (quando aberto como app)',
    group: 'Geral',
  },

  {
    key: 'sidebar-bg',
    label: 'Sidebar de navegacao: fundo do bloco',
    group: 'Sidebar',
  },
  {
    key: 'sidebar-text',
    label: 'Sidebar de navegacao: cor do texto',
    group: 'Sidebar',
  },

  {
    key: 'conv-action-bg',
    label: 'Painel de acoes da conversa: fundo do bloco',
    group: 'Painel de acoes',
  },
  {
    key: 'conv-action-text',
    label: 'Painel de acoes da conversa: cor do texto',
    group: 'Painel de acoes',
  },
  {
    key: 'iara-toggle-on',
    label: 'Botao Assistente IAra: ligado',
    group: 'Painel de acoes',
  },
  {
    key: 'iara-toggle-off',
    label: 'Botao Assistente IAra: desligado',
    group: 'Painel de acoes',
  },

  {
    key: 'reply-msg-bg',
    label: 'Mensagem: fundo da caixa de texto',
    group: 'ReplyBox - Mensagem',
  },
  {
    key: 'reply-msg-text',
    label: 'Mensagem: cor do texto',
    group: 'ReplyBox - Mensagem',
  },
  {
    key: 'reply-msg-bubble',
    label: 'Mensagem: cor do balao enviado',
    group: 'ReplyBox - Mensagem',
  },

  {
    key: 'reply-private-bg',
    label: 'Mensagem privada: fundo da caixa e do balao',
    group: 'ReplyBox - Mensagem privada',
  },
  {
    key: 'reply-private-text',
    label: 'Mensagem privada: cor do texto',
    group: 'ReplyBox - Mensagem privada',
  },

  {
    key: 'reply-iara-accent',
    label: 'IAra: cor de destaque (botoes, caixa de texto, balao do usuario)',
    group: 'ReplyBox - IAra',
  },
  {
    key: 'reply-iara-text',
    label: 'IAra: cor do texto',
    group: 'ReplyBox - IAra',
  },
  {
    key: 'reply-iara-bubble',
    label: 'IAra: cor do balao de resposta',
    group: 'ReplyBox - IAra',
  },
];

const TOKEN_KEYS = COLOR_TOKENS.map(t => t.key);

// Perfis padrao. Cada modo (dark/light) tem 4 perfis; o primeiro de cada
// modo imita as cores nativas do WhatsApp Web, pedido explicito do Caio.
export const COLOR_PROFILES = {
  dark: [
    {
      id: 'dark-whatsapp',
      name: 'WhatsApp',
      colors: {
        'dashboard-bg': '#0B141A',
        brand: '#00A884',
        'browser-titlebar': '#202C33',
        'sidebar-bg': '#111B21',
        'sidebar-text': '#8696A0',
        'conv-action-bg': '#111B21',
        'conv-action-text': '#E9EDEF',
        'iara-toggle-on': '#00A884',
        'iara-toggle-off': '#F15C6D',
        'reply-msg-bg': '#2A3942',
        'reply-msg-text': '#E9EDEF',
        'reply-msg-bubble': '#005C4B',
        'reply-private-bg': '#3A2E1F',
        'reply-private-text': '#F9E2AE',
        'reply-iara-accent': '#00A884',
        'reply-iara-text': '#E9EDEF',
        'reply-iara-bubble': '#005C4B',
      },
    },
    {
      id: 'dark-odmax',
      name: 'ODMax Roxo',
      colors: {
        'dashboard-bg': '#1C1D20',
        brand: '#7C5CFC',
        'browser-titlebar': '#1C1D20',
        'sidebar-bg': '#1C1D20',
        'sidebar-text': '#B2B7BE',
        'conv-action-bg': '#16171A',
        'conv-action-text': '#EDEEF0',
        'iara-toggle-on': '#22C55E',
        'iara-toggle-off': '#EF4444',
        'reply-msg-bg': '#141517',
        'reply-msg-text': '#EDEEF0',
        'reply-msg-bubble': '#3B5BDB',
        'reply-private-bg': '#3A2E14',
        'reply-private-text': '#F9E2AE',
        'reply-iara-accent': '#12B981',
        'reply-iara-text': '#E9F9F1',
        'reply-iara-bubble': '#0F6B4E',
      },
    },
    {
      id: 'dark-oceano',
      name: 'Oceano',
      colors: {
        'dashboard-bg': '#0D1B21',
        brand: '#22B8CF',
        'browser-titlebar': '#0D1B21',
        'sidebar-bg': '#0F232B',
        'sidebar-text': '#9FC1CB',
        'conv-action-bg': '#0F232B',
        'conv-action-text': '#E3F3F6',
        'iara-toggle-on': '#20C997',
        'iara-toggle-off': '#FA5252',
        'reply-msg-bg': '#123039',
        'reply-msg-text': '#E3F3F6',
        'reply-msg-bubble': '#1971C2',
        'reply-private-bg': '#332B12',
        'reply-private-text': '#FFE066',
        'reply-iara-accent': '#20C997',
        'reply-iara-text': '#E3F3F6',
        'reply-iara-bubble': '#0B7285',
      },
    },
    {
      id: 'dark-ambar',
      name: 'Ambar',
      colors: {
        'dashboard-bg': '#1F1A15',
        brand: '#F59F00',
        'browser-titlebar': '#1F1A15',
        'sidebar-bg': '#211B15',
        'sidebar-text': '#C9B8A3',
        'conv-action-bg': '#1B1712',
        'conv-action-text': '#F3EBDF',
        'iara-toggle-on': '#40C057',
        'iara-toggle-off': '#E03131',
        'reply-msg-bg': '#171310',
        'reply-msg-text': '#F3EBDF',
        'reply-msg-bubble': '#D9480F',
        'reply-private-bg': '#332612',
        'reply-private-text': '#FFD43B',
        'reply-iara-accent': '#37B24D',
        'reply-iara-text': '#F3EBDF',
        'reply-iara-bubble': '#2B8A3E',
      },
    },
    {
      id: 'dark-slate-nordico',
      name: 'Slate Nórdico',
      colors: {
        'dashboard-bg': '#1C222C',
        brand: '#55AAE7',
        'browser-titlebar': '#1C222C',
        'sidebar-bg': '#242C38',
        'sidebar-text': '#A4ACB7',
        'conv-action-bg': '#242C38',
        'conv-action-text': '#EEEFF2',
        'iara-toggle-on': '#4DCB90',
        'iara-toggle-off': '#EF6F6F',
        'reply-msg-bg': '#2E3848',
        'reply-msg-text': '#EEEFF2',
        'reply-msg-bubble': '#55AAE7',
        'reply-private-bg': '#3A3220',
        'reply-private-text': '#F9E2AE',
        'reply-iara-accent': '#4DCB90',
        'reply-iara-text': '#EEEFF2',
        'reply-iara-bubble': '#2E7D5C',
      },
    },
  ],
  light: [
    {
      id: 'light-whatsapp',
      name: 'WhatsApp',
      colors: {
        'dashboard-bg': '#F0F2F5',
        brand: '#008069',
        'browser-titlebar': '#008069',
        'sidebar-bg': '#F0F2F5',
        'sidebar-text': '#54656F',
        'conv-action-bg': '#FFFFFF',
        'conv-action-text': '#111B21',
        'iara-toggle-on': '#00A884',
        'iara-toggle-off': '#E63946',
        'reply-msg-bg': '#FFFFFF',
        'reply-msg-text': '#111B21',
        'reply-msg-bubble': '#D9FDD3',
        'reply-private-bg': '#FFF3C4',
        'reply-private-text': '#6B4E00',
        'reply-iara-accent': '#00A884',
        'reply-iara-text': '#0B141A',
        'reply-iara-bubble': '#D9FDD3',
      },
    },
    {
      id: 'light-odmax',
      name: 'ODMax Roxo',
      colors: {
        'dashboard-bg': '#F7F7F7',
        brand: '#7C3AED',
        'browser-titlebar': '#7C3AED',
        'sidebar-bg': '#F7F7F7',
        'sidebar-text': '#4F545C',
        'conv-action-bg': '#FFFFFF',
        'conv-action-text': '#0F1113',
        'iara-toggle-on': '#16A34A',
        'iara-toggle-off': '#DC2626',
        'reply-msg-bg': '#FEFEFE',
        'reply-msg-text': '#0F1113',
        'reply-msg-bubble': '#DCE6FF',
        'reply-private-bg': '#FFF8E1',
        'reply-private-text': '#7A5900',
        'reply-iara-accent': '#10B77F',
        'reply-iara-text': '#0B3B2E',
        'reply-iara-bubble': '#E3F7EF',
      },
    },
    {
      id: 'light-oceano',
      name: 'Oceano',
      colors: {
        'dashboard-bg': '#F1F8FA',
        brand: '#0C8599',
        'browser-titlebar': '#0C8599',
        'sidebar-bg': '#EAF5F7',
        'sidebar-text': '#3F5F66',
        'conv-action-bg': '#FFFFFF',
        'conv-action-text': '#0D2B31',
        'iara-toggle-on': '#12B886',
        'iara-toggle-off': '#E03131',
        'reply-msg-bg': '#FFFFFF',
        'reply-msg-text': '#0D2B31',
        'reply-msg-bubble': '#D0EBFF',
        'reply-private-bg': '#FFF3BF',
        'reply-private-text': '#665400',
        'reply-iara-accent': '#12B886',
        'reply-iara-text': '#0D2B31',
        'reply-iara-bubble': '#C3FAE8',
      },
    },
    {
      id: 'light-ambar',
      name: 'Ambar',
      colors: {
        'dashboard-bg': '#FBF7F2',
        brand: '#E8590C',
        'browser-titlebar': '#E8590C',
        'sidebar-bg': '#F6EFE6',
        'sidebar-text': '#7A5C3E',
        'conv-action-bg': '#FFFFFF',
        'conv-action-text': '#241A0E',
        'iara-toggle-on': '#2B8A3E',
        'iara-toggle-off': '#C92A2A',
        'reply-msg-bg': '#FFFFFF',
        'reply-msg-text': '#241A0E',
        'reply-msg-bubble': '#FFE8CC',
        'reply-private-bg': '#FFF3BF',
        'reply-private-text': '#665400',
        'reply-iara-accent': '#2B8A3E',
        'reply-iara-text': '#241A0E',
        'reply-iara-bubble': '#D3F9D8',
      },
    },
  ],
};

export function findProfile(mode, profileId) {
  const list = COLOR_PROFILES[mode] || [];
  return list.find(p => p.id === profileId) || list[0];
}

function hexToRgbTriplet(hex) {
  const match = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!match) return null;
  const [, r, g, b] = match;
  return `${parseInt(r, 16)} ${parseInt(g, 16)} ${parseInt(b, 16)}`;
}

const STYLE_TAG_ID = 'odtravel-runtime-theme';

// Cache local dos tokens de cor já resolvidos (por modo), lido de forma
// síncrona pelo script inline em vueapp.html.erb (ver esse arquivo) antes
// do bundle Vue carregar. Sem isso, a UI sempre nasce com as cores padrão
// do Chatwoot e só troca pro perfil real depois do round-trip de
// `accounts/get` (Account.settings vem do backend, não de localStorage) —
// esse é o "flash de tema" ao recarregar a página. Guardar os `colors` já
// resolvidos (e não profileId+overrides) mantém o script do erb simples:
// ele só injeta o <style>, sem reimplementar resolveColors/hexToRgbTriplet.
const THEME_CACHE_KEY = 'odtravel_theme_cache';

function cacheResolvedColors(mode, colors) {
  try {
    const raw = window.localStorage.getItem(THEME_CACHE_KEY);
    const cache = raw ? JSON.parse(raw) : {};
    cache[mode] = colors;
    window.localStorage.setItem(THEME_CACHE_KEY, JSON.stringify(cache));
  } catch {
    // localStorage indisponível (modo privado etc) — só afeta o cache do
    // boot rápido, a aplicação em si já rodou normalmente.
  }
}

// `overrides` = valores customizados pelo usuario por cima do perfil
// (Account.settings.odtravel_color_profiles?.[mode]?.[profileId]).
export function resolveColors(mode, profileId, overrides = {}) {
  const profile = findProfile(mode, profileId);
  const merged = { ...profile.colors };
  TOKEN_KEYS.forEach(key => {
    if (overrides[key]) merged[key] = overrides[key];
  });
  return merged;
}

export function applyColorPalette(mode, profileId, overrides = {}) {
  const colors = resolveColors(mode, profileId, overrides);
  cacheResolvedColors(mode, colors);
  const rgb = key => hexToRgbTriplet(colors[key]);

  const varRules = [
    `--background-color: ${rgb('dashboard-bg')};`,
    `--surface-1: ${rgb('dashboard-bg')};`,
    `--sidebar-nav-background: ${rgb('sidebar-bg')};`,
    `--sidebar-nav-text: ${rgb('sidebar-text')};`,
    `--surface-2: ${rgb('conv-action-bg')};`,
    `--conv-action-text: ${rgb('conv-action-text')};`,
    `--reply-msg-background: ${rgb('reply-msg-bg')};`,
    `--reply-msg-text: ${rgb('reply-msg-text')};`,
    `--reply-private-text: ${rgb('reply-private-text')};`,
  ].join('\n');

  const css = `
:root, body.dark {
${varRules}
}
.odtravel-sidebar-nav { --slate-11: var(--sidebar-nav-text); --slate-12: var(--sidebar-nav-text); }
.odtravel-conv-action { --slate-11: var(--conv-action-text); --slate-12: var(--conv-action-text); }
.reply-box.is-iara-consult { --green-9: ${rgb('reply-iara-accent')}; --green-12: ${rgb('reply-iara-text')}; }
:root .bg-n-brand { background-color: ${colors.brand} !important; }
:root .text-n-brand { color: ${colors.brand} !important; }
:root .outline-n-brand { outline-color: ${colors.brand} !important; }
.reply-box { background-color: ${colors['reply-msg-bg']} !important; }
.reply-box .ProseMirror { color: ${colors['reply-msg-text']} !important; }
.reply-box.is-private { background-color: ${colors['reply-private-bg']} !important; }
.reply-box.is-private .ProseMirror { color: ${colors['reply-private-text']} !important; }
.reply-box.is-iara-consult { background-color: ${colors['reply-iara-accent']}1A !important; }
.right-bubble.bg-n-solid-blue, .left-bubble.bg-n-solid-blue { background-color: ${colors['reply-msg-bubble']} !important; }
.right-bubble.bg-n-solid-amber, .left-bubble.bg-n-solid-amber { background-color: ${colors['reply-private-bg']} !important; }
.reply-box.is-iara-consult .bg-n-solid-green { background-color: ${colors['reply-iara-bubble']} !important; }
.bg-green-600 { background-color: ${colors['iara-toggle-on']} !important; }
.hover\\:bg-green-700:hover { background-color: ${colors['iara-toggle-on']} !important; filter: brightness(0.9); }
.bg-red-600 { background-color: ${colors['iara-toggle-off']} !important; }
.hover\\:bg-red-700:hover { background-color: ${colors['iara-toggle-off']} !important; filter: brightness(0.9); }
`;

  let styleTag = document.getElementById(STYLE_TAG_ID);
  if (!styleTag) {
    styleTag = document.createElement('style');
    styleTag.id = STYLE_TAG_ID;
    document.head.appendChild(styleTag);
  }
  styleTag.textContent = css;

  const themeColorMeta = document.querySelector('meta[name="theme-color"]');
  if (themeColorMeta)
    themeColorMeta.setAttribute('content', colors['browser-titlebar']);
}

// `settings` = Account.settings inteiro. Le odtravel_active_color_profile
// ({ dark, light }, default pro primeiro perfil de cada modo) e
// odtravel_color_profiles ({ dark: { [profileId]: overrides }, light: {...} }).
export function applyColorPaletteFromSettings(settings, isDarkMode) {
  const mode = isDarkMode ? 'dark' : 'light';
  const activeProfile = settings?.odtravel_active_color_profile?.[mode];
  const profileId = activeProfile || COLOR_PROFILES[mode][0].id;
  const overrides =
    settings?.odtravel_color_profiles?.[mode]?.[profileId] || {};
  applyColorPalette(mode, profileId, overrides);
}
